import { schema } from 'normalizr';
export const groupSchema = new schema.Entity('group', {}, {
    idAttribute: 'userId'
});

//# sourceMappingURL=group.js.map